import { remove, maxBy, find } from 'lodash';

const DEFAULT_POPUP_Z_INDEX = 1002;

const chartPopupStore = {
  namespaced: true,
  state: () => ({
    popupVisibleStates: []
  }),
  getters: {
    popupVisibleStates: (state) => state.popupVisibleStates,
    getPopupZIndexById: (state) => (popupId) => {
      const popup = find(state.popupVisibleStates, (item) => item.id === popupId);
      return popup ? popup.zIndex : null;
    }
  },
  mutations: {
    setPopupVisibleStates: (state, item) => state.popupVisibleStates.push(item)
  },
  actions: {
    setPopupVisibleStates: ({ commit, state }, popupId) => {
      const topPopup = maxBy(state.popupVisibleStates, 'zIndex');
      const maxZIndex = topPopup ? topPopup.zIndex : DEFAULT_POPUP_Z_INDEX;
      commit('setPopupVisibleStates', { id: popupId, zIndex: maxZIndex + 1 });
    },
    removePopup: ({ state }, popupId) => {
      remove(state.popupVisibleStates, ['id', popupId]);
    }
  }
};

export default chartPopupStore;
